import { render } from "./LprGraph.vue?vue&type=template&id=04f2f24c&scoped=true"
import script from "./LprGraph.vue?vue&type=script&lang=js"
export * from "./LprGraph.vue?vue&type=script&lang=js"

import "./LprGraph.vue?vue&type=style&index=0&id=04f2f24c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04f2f24c"]])

export default __exports__